<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="selectField" />

    <!-- 수행평가 대상 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t("수행평가 대상") }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t("부서(업체)명") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.field_name }}</p>
          <company-selector v-else v-model="form.inputA_1" :fieldId="form.stdInfo.field_id" :field-name="form.field_name" :readonly="board.readonly || !form.stdInfo.field_id" @select="onSelectFieldSelector" />
        </div>
        <div>
          <div>{{ $t("피평가자") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("평가일") }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_6 }}</p>
          <date-selector v-else v-model="form.inputA_6" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!--    청소(미화)-->
    <table-inspect-column7
      class="mt-28px"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      title="업무 수행 여부"
      v-model="form.inspectList"
      :is-note="true"
      :table-header-title="'업무 수행 여부'"
      :table-header-yes="'Yes'"
      :table-header-no="'No'"
      :table-header-na="'N/A'"
      :table-header-note="'개선요망 사항'"
      :footer="isKorean ? $t('※ (중처법=중대재해처벌 등에 관한 법률. 산안법=산업안전보건법)') : ''"
      @update-list-check="updateListCheck"
      @update-note="updateListNote"
    />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t("결재란") }}</h5>
      </div>
      <name-with-signature-row :label-name="$t('작성자')" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row :label-name="$t('검토자')" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row :label-name="$t('회람자')" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row :label-name="$t('승인자')" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" :section-title="$t('사진대지')" :placeholder="$t('점검 현장 사진')" class="mt-28px" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import TableInspect from "@/components/TableInspect";
import TableInspectColumn7 from "@/components/TableInspectColumn7";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Print from "@/views/boards/single-page/286/Print.vue";

export default {
  components: {
    Print,
    NameWithSignatureRow,
    CompanySelector,
    PhotoUploadGridModule,
    TableInspectColumn7,
    TableInspect,
    DateSelector,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  computed: {
    isKorean() {
      const locale = (this.$i18n && this.$i18n.locale) || (typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage)) || "";
      return String(locale).toLowerCase().startsWith("ko");
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        field_name: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        inspectList: [
          {
            id: 1,
            col1: 1,
            col2: "중처법시행령 제4조",
            label: "사업장 중대재해예방 종합계획 수립",
            title: "사업장의 산업재해 예방계획 수립",
            is_checked: "",
          },
          {
            id: 2,
            col1: 2,
            col2: "산업법 제25조",
            label: "안전보건관리규정 작성 및 배포",
            title: "안전보건관리규정의 작성 및 변경",
            is_checked: "",
          },
          {
            id: 3,
            col1: 3,
            col2: "산안법 제29조",
            label: "신규 채용시 교육(누락없이) 실시",
            title: "안전보건교육 실시",
            is_checked: "",
          },
          {
            id: 4,
            col1: 4,
            col2: "산안법 제125조",
            label: "작업환경 개선을 위한 조치(휴게실, 휴게시간 등) 및 작업환경 측정",
            title: "작업환경측정 및 작업환경의 점검·개선",
            is_checked: "",
          },
          {
            id: 5,
            col1: 5,
            col2: "산안법 제132조",
            label: "근로자 건강진단 의무",
            title: "종사자의 건강진단 및 건강관리",
            is_checked: "",
          },
          {
            id: 6,
            col1: 6,
            col2: "산안법 제57조",
            label: "해당 부서별조치(산업재해조사표, 재발방지대책수립)",
            title: "산업재해 원인조사 및 재발방지대책 수립",
            is_checked: "",
          },
          {
            id: 7,
            col1: 7,
            col2: "산안법 제4조",
            label: "해당 부서별 산재통계 조사 및 기록",
            title: "산업재해 통계의 기록 및 유지",
            is_checked: "",
          },
          {
            id: 8,
            col1: 8,
            col2: "산안법 제15조",
            label: "해당 부서별 구입품목 확인",
            title: "안전장치 및 보호구 구입시 적격품 여부 확인",
            is_checked: "",
          },
          {
            id: 9,
            col1: 9,
            col2: "산안법 제36조",
            label: "정기평가, 수시평가 등",
            title: "위험성평가의 실시",
            is_checked: "",
          },
          {
            id: 10,
            col1: 10,
            col2: "산안법 제129조",
            label: "유해요인 조사 등",
            title: "종사자의 위험, 건강장해 방지에 관한 사항",
            is_checked: "",
          },
          {
            id: 11,
            col1: 11,
            col2: "산안법시행령 53조",
            label: "관계수급인의 유해 위험요인에 대한 안전조치 및 위험성평가의 실시 확인",
            title: "도급·용역·위탁사업 등",
            is_checked: "",
          },
          {
            id: 12,
            col1: 12,
            col2: "중처법 제4조",
            label: "작업의 중지와 대피에 대한 운영(필요시)",
            title: "도급·용역·위탁사업 등",
            is_checked: "",
          },
          {
            id: 13,
            col1: 13,
            col2: "산안법 제64조",
            label: "도급시 산업재해 예방조치(협의체 운영 등)",
            title: "도급·용역·위탁사업 등",
            is_checked: "",
          },
          {
            id: 14,
            col1: 14,
            col2: "산안법 제72조",
            label: "관계수급인 간 산업안전보건관리비의 사용에 관한 협의·조정 및 그 집행의 감독",
            title: "도급·용역·위탁사업 등",
            is_checked: "",
          },
          {
            id: 15,
            col1: 15,
            col2: "산안법 제83조",
            label: "안전인증대상 기계등과 자율안전확인대상 기계등의 사용여부 확인",
            title: "도급·용역·위탁사업 등",
            is_checked: "",
          },
        ],
      },
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.field_name = value.field_name;
      this.$emit("selectField", value);
    },
    updateListCheck(indexRows, text) {
      console.log("updateListCheck (indexRows, text)", indexRows, text);
      this.form.inspectList[indexRows].is_checked = text;
    },
    updateListNote(indexRows, text) {
      this.form.inspectList[indexRows].note = text;
    },
    selectField() {
      this.form.inputA_1 = "";
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
